import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Loading from '../Loading';
import { Fragment } from 'react';
import Modal from '../Modal';
import { Link } from 'react-router-dom';
import SalePlatformIcon from './SalePlatformIcon';
import AggregatorIcon from './AggregatorIcon';
import Webcam from 'react-webcam';
import BarcodeReader from 'react-barcode-reader';
import ScanningBox from '../ScanningBox';
import { DateInput } from '@blueprintjs/datetime';
import moment from 'moment';

const base = 'all-orders';

@inject('AllOrdersStore', 'LiveDispatchStore')
@observer
class AllOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSingleOrderModal: false,
            singleOrder: {},
            from: ""
        };
        this.webcamRef = React.createRef();
    }

    componentDidMount() {
        const {
            location,
            AllOrdersStore: { handleGetAllOrders },
        } = this.props;
        this.setState({from : location ? location.state ? location.state.from : "" : ""});
        handleGetAllOrders();
    }

    handleError = (err) => {};

    handleScanWrapper = (scannedBarcode) => {
        const { LiveDispatchStore, ScanningStore } = this.props;
        const { setItemImage, handledScannedItem, handledScannedBag, handledScannedWarmerItem, displayErrorResultFunc } =
            LiveDispatchStore;
        const { handleScan } = ScanningStore;
        if (this.webcamRef.current) {
            const image = this.webcamRef.current.getScreenshot();
            setItemImage(image);
        }
        let isBagQRCode = scannedBarcode.split('-').length == 1;
        if (isBagQRCode) {
            handledScannedBag(scannedBarcode);
        } else {
            handleScan(scannedBarcode, handledScannedItem, handledScannedWarmerItem, displayErrorResultFunc);
        }
    };

    handleShowSingleOrderModal = (order) => {
        this.setState({showSingleOrderModal : true, singleOrder: order});
    }
    closeModal = () => {
        this.setState({showSingleOrderModal: false})
    }

    handleDateChange = (date) => {
        const {
            AllOrdersStore: { handleGetAllOrders },
        } = this.props;
        const formattedDate = moment(date).format('DD-MM-YYYY');
        handleGetAllOrders(formattedDate)
    }

    normalizeWhatsappPhoneNumber = (phoneNumber) => {
        const digits = `${phoneNumber || ''}`.replace(/\D/g, '');

        if (!digits) {
            return '';
        }

        if (digits.indexOf('60') === 0) {
            return digits;
        }

        if (digits.indexOf('0') === 0) {
            return `60${digits.slice(1)}`;
        }

        return digits;
    }

    getWhatsappUrl = (phoneNumber) => {
        const normalizedPhoneNumber = this.normalizeWhatsappPhoneNumber(phoneNumber);

        return normalizedPhoneNumber ? `https://wa.me/${normalizedPhoneNumber}` : '';
    }

    getWhatsappQrUrl = (phoneNumber) => {
        const whatsappUrl = this.getWhatsappUrl(phoneNumber);

        if (!whatsappUrl) {
            return '';
        }

        return `https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=8&data=${encodeURIComponent(whatsappUrl)}`;
    }

    render() {
        const { AllOrdersStore, LiveDispatchStore } = this.props;
        const { loading, orders } = AllOrdersStore;
        const {
            showSingleOrderModal,
            singleOrder,
            from
        } = this.state;
        const {
            itemImage: image,
            itemScanLoading,
            scannedItem,
            scannedItemSKU,
            scannedItemError,
            showScannedItemOnLiveDispatch,
            originalItemImageLink,
        } = LiveDispatchStore;
        const customerPhoneNumber = singleOrder.customer ? singleOrder.customer.mobileno : '';
        const whatsappUrl = this.getWhatsappUrl(customerPhoneNumber);
        const whatsappQrUrl = this.getWhatsappQrUrl(customerPhoneNumber);

        if (loading) {
            return <Loading />;
        }

        if (!orders) {
            return <h1> No orders to show</h1>
        }

        const allOrderNetTotalExcludingAggDeliveryFee = orders
            .filter(order => 
                ((order.payment_method == "Cash" && order.status == "Delivered") || 
                (order.transaction_status == "Complete" && order.status != "Cancelled")))
            .reduce((acc, order) => {
                const aggDeliveryFee = order.aggregator_order_id ? (order.delivery_charge ?? 0) : 0;
                return acc + (order.net_total ?? 0) - aggDeliveryFee;
            }, 0)
            .toFixed(2);

        const isProductionCompleted = (order) => {
            if (order.item_type === "Combo") {
                return order.combo_sub_items?.every(subItem => isProductionCompleted(subItem));
            }
            return order.production_completed ?? false;
        };
        
        const getServiceTime = (order) => {
            if (
                !order.menu_item?.every(isProductionCompleted) ||
                !order.production_started_at ||
                !order.last_scanned_at
            ) {
                return null;
            }
            // Calculate the elapsed time in mm:ss format
            const elapsedMillis = order.last_scanned_at - order.production_started_at;
            const elapsedMinutes = Math.floor(elapsedMillis / 60000);
            const elapsedSeconds = Math.floor((elapsedMillis % 60000) / 1000);

            return `${elapsedMinutes}:${String(elapsedSeconds).padStart(2, "0")}`;
        };


        return (
            <Fragment>
                <div className={`container ${base}__toolbar`} style={{margin: '0px', width: '100%', paddingTop: '5px', textAlign : 'center'}}>
                <Link to={from}>
                    <button className={`${base}__view-all-orders  m0 mlm`} style={{position: 'absolute', left: '0px'}}>
                        Go Back
                    </button>
                </Link>
                    <div className={`${base}__date-input m0 mlm`} style={{position: 'absolute', right: '0px'}}>
                        <DateInput
                                formatDate={ (date) => moment(date).format('DD/MM/YYYY') }
                                onChange={ (date) => this.handleDateChange(date) }
                                parseDate={ (str) => moment(str, 'DD/MM/YYYY').toDate() }
                                maxDate={new Date()}
                                minDate={moment().subtract(6, 'days').toDate()}
                                placeholder="Date"
                        />
                    </div>
                    <h1 style={{lineHeight: '55px'}}>All Orders</h1>
                </div>
                <div className={`container ${base}__table_scroll`} style={{margin: '0px', width: '100%', padding: '0px'}}>
                    <div className={`${base}__webcam-area`}>
                        <Webcam
                            audio={false}
                            ref={this.webcamRef}
                            screenshotFormat="image/jpeg"
                            className="webcam"
                            screenshotQuality={1}
                            forceScreenshotSourceSize={true}
                            videoConstraints={{
                                height: 1080,
                                width: 1920,
                            }}
                        />
                    </div>
                    <div className={`col-xs-12 ${base}__table_header`}
                        style={{top: '140px', position: 'absolute', backgroundColor: '#303234', color: 'white', 
                        zIndex: '10', textAlign: 'left', paddingTop: '10px', left: '0px'}}>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">ORDER NUMBER</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">ORDER TIME</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">BAG NUMBER</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">CUSTOMER NAME</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">CUSTOMER PHONE NUMBER</h3>
                            </div>
                            <div className="col-xs-2">
                                <h3 className="text--bolder">ITEM</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">STATUS</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">PAYMENT METHOD</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">PAYMENT DONE?</h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">NET TOTAL <br /> ({allOrderNetTotalExcludingAggDeliveryFee}) </h3>
                            </div>
                            <div className="col-xs-1">
                                <h3 className="text--bolder">SERVICE TIME</h3>
                            </div>
                        </div>              
                    {orders && orders.map((order, key) => {
                        const serviceTime = getServiceTime(order);
                        
                        return (
                            <div className={`${base}__table_row row col-xs-12 text--left`} onClick={() => this.handleShowSingleOrderModal(order)}
                                style = {key=== 0 ? {marginTop: '90px'} : {}} >
                                <div className='col-xs-1' style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <div className='col-xs-1' style={{marginRight: '5px', paddingLeft: '0px'}}>
                                        <SalePlatformIcon
                                            key={order.order_number}
                                            order={order}
                                        />
                                    </div>
                                    <div className='col-xs-8' style={(order.order_mode == "DELIVERY" && (order.status == "Pending" || order.status == "Unconfirmed"))
                                        || (order.order_mode == "DINE_IN" && order.status != "Delivered")
                                        || (order.order_mode == "PICK_UP" && (!order.bag_scanned_at && order.status != "Delivered" && order.status != "Intransit")
                                        || (order.status == "Cancelled")) ? {color: 'red'} : {}}>
                                        {order.order_id}
                                    </div>
                                </div>
                                <div className='col-xs-1' style={(order.order_mode == "DELIVERY" && (order.status == "Pending" || order.status == "Unconfirmed"))
                                || (order.order_mode == "DINE_IN" && order.status != "Delivered")
                                || (order.order_mode == "PICK_UP" && (!order.bag_scanned_at && order.status != "Delivered" && order.status != "Intransit")
                                || (order.status == "Cancelled")) ? {color: 'red'} : {}}>
                                    {new Date(order.created_date).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
                                </div>
                                <div className='col-xs-1'>
                                    {order.aggregator_order_id ? (order.bag_number ? order.bag_number + ' (' + order.aggregator_order_id + ')' : order.aggregator_order_id) : 
                                        (order.bag_number ? order.bag_number : '-')}
                                </div>
                                <div className='col-xs-1 text--uppercase'>
                                    {order.order_mode === "PANDU_LALU" ? order.dine_in_information.remark : (order.customer.alias || order.alias)}
                                </div>
                                <div className='col-xs-1'>
                                    {order.customer.mobileno}
                                </div>
                                <div className='col-xs-2'>
                                    {order.menu_item ? order.menu_item.map((item, index) => (
                                        <span>
                                            {item.quantity > 1 ? item.quantity + " x " : "" } {item.name}{index != (order.menu_item.length - 1) ? ", " : ""} 
                                        </span>
                                    )) : ""}
                                </div>
                                <div className='col-xs-1' style={(order.order_mode == "DELIVERY" && (order.status == "Pending" || order.status == "Unconfirmed"))
                                    || (order.order_mode == "DINE_IN" && order.status != "Delivered")
                                    || (order.order_mode == "PICK_UP" && (!order.bag_scanned_at && order.status != "Delivered" && order.status != "Intransit")
                                    || (order.status == "Cancelled"))? {color: 'red'} : {color: '#03C875'}}>
                                    {order.status ? order.status.toUpperCase() : ""}
                                </div>
                                <div className='col-xs-1'>
                                    {order.payment_method ? order.payment_method : "-"}
                                </div>
                                <div className='col-xs-1'>
                                <img src={(order.transaction_status === "Complete" || (order.payment_method === "Cash" && order.status === "Delivered")) ? 
                                                'https://image.popcontent.link/green_checkmark.svg' :
                                                            'https://image.popcontent.link/red_cross.svg'} />
                                </div>
                                <div className='col-xs-1 '>
                                    {order.net_total ? order.net_total.toFixed(2) : "" }
                                </div>
                                <div className='col-xs-1'>
                                    {serviceTime ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span>{serviceTime}</span>
                                            {(!order.aggregator_order_id && 
                                            (order.order_mode === 'PICK_UP' || order.order_mode === 'DINE_IN')) && (
                                                parseInt(serviceTime.split(":")[0]) >= 5 ? (
                                                    <svg className="icon-thumbs-down"
                                                        style={{
                                                        height: '25px',
                                                        width: '25px',
                                                        marginLeft: '10px',
                                                        transform: 'translateY(4px)'
                                                    }}>
                                                        <use xlinkHref="#icon-thumbs-down" />
                                                    </svg>
                                                ) : (
                                                    <svg className="icon-thumbs-up"
                                                        style={{
                                                        height: '25px',
                                                        width: '25px',
                                                        marginLeft: '10px',
                                                        transform: 'translateY(-4px)'
                                                    }}>
                                                        <use xlinkHref="#icon-thumbs-up" />
                                                    </svg>
                                                )
                                            )} 
                                        </div>
                                    ) : ""}
                                </div>
                            </div>
                        );
                    })}

                    {showSingleOrderModal && (
                        <Fragment>
                            <button type="button" className={`${base}__modal_close_button`} aria-label="Close" onClick={this.closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <Modal className={`${base}__detail-modal`} height={'80vh'} onBackdropClicked={this.closeModal}>
                                <div className={`${base}__modal_table_title`}>
                                    <SalePlatformIcon
                                        key={singleOrder.order_number}
                                        order={singleOrder}
                                        isModal={true}
                                    />
                                    <div style={{marginLeft: "24px"}}>
                                        Order Number: {singleOrder.order_id}
                                    </div>
                                </div>
                                <hr />
                                <div className={`row ${base}__modal_table_body`}>
                                    <div className={`row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Order Time
                                        </div>
                                        <div className='col-xs-8' style={(singleOrder.order_mode == "DELIVERY" && (singleOrder.status == "Pending" || singleOrder.status == "Unconfirmed"))
                                        || (singleOrder.order_mode == "DINE_IN" && singleOrder.status != "Delivered")
                                        || (singleOrder.order_mode == "PICK_UP" && (!singleOrder.bag_scanned_at && singleOrder.status != "Delivered" && singleOrder.status != "Intransit"))
                                        || (singleOrder.status == "Cancelled") ? {color: 'red'} : {}}>
                                            {new Date(singleOrder.created_date).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', hour12: true})}
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Bag/Table Number
                                        </div>
                                        <div className='col-xs-8'>
                                        {singleOrder.aggregator_order_id ? singleOrder.aggregator_order_id : 
                                            (singleOrder.table_number ? ("TABLE " + singleOrder.table_number) : ("BAG " + singleOrder.bag_number ? singleOrder.bag_number : "-"))}
                                        </div>
                                    </div>
                                    {
                                        (singleOrder.sale_platform && singleOrder.sale_platform.includes("-")) && (
                                            <div className={`row ${base}__modal_table_row`}>
                                                <div className='col-xs-4 text--gray'>
                                                    Aggregator
                                                </div>
                                                <div className='col-xs-8'>
                                                    <AggregatorIcon 
                                                        key={singleOrder.order_number}
                                                        order={singleOrder}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Customer Name
                                        </div>
                                        <div className='col-xs-8 text--uppercase'>
                                            {singleOrder.order_mode === "PANDU_LALU" ? singleOrder.dine_in_information.remark : (singleOrder.customer.alias || singleOrder.alias)}
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`} style={{marginBottom: "32px"}}>
                                        <div className='col-xs-4 text--gray'>
                                            Customer Phone Number
                                        </div>
                                        <div className='col-xs-8'>
                                            {customerPhoneNumber}
                                        </div>
                                    </div>
                                    {whatsappQrUrl ? (
                                        <div className={`row ${base}__modal_table_row`} style={{marginBottom: "32px"}}>
                                            <div className='col-xs-4 text--gray'>
                                                Scan To WhatsApp Customer
                                            </div>
                                            <div className='col-xs-8'>
                                                <a
                                                    className={`${base}__whatsapp_qr_link`}
                                                    href={whatsappUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        className={`${base}__whatsapp_qr`}
                                                        src={whatsappQrUrl}
                                                        alt={`WhatsApp QR for ${customerPhoneNumber}`}
                                                    />
                                                    <span className={`${base}__whatsapp_qr_url`}>
                                                        {whatsappUrl.replace('https://', '')}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    ) : null}
                                    {singleOrder.menu_item ? singleOrder.menu_item.map((item, index) => (
                                        <div className={`row`}>
                                            <div className='col-xs-4 text--gray'>
                                                {index == 0 ? 'Items' : ''}
                                            </div>
                                            <div className='col-xs-8'>
                                                <div>{item.quantity} x {item.name}</div>
                                                {item.family_combo && item.combo_sub_items?.length > 0 && (
                                                    <ul style={{ marginTop: '4px' }}>
                                                        {item.combo_sub_items.map((subItem, subIndex) => (
                                                            <li key={subItem.id || subIndex}>
                                                                {subItem.quantity} x {subItem.name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                    )) : ""}
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Status
                                        </div>
                                        <div className='col-xs-8' style={(singleOrder.order_mode == "DELIVERY" && (singleOrder.status == "Pending" || singleOrder.status == "Unconfirmed"))
                                        || (singleOrder.order_mode == "DINE_IN" && singleOrder.status != "Delivered")
                                        || (singleOrder.order_mode == "PICK_UP" && (!singleOrder.bag_scanned_at && singleOrder.status != "Delivered" && singleOrder.status != "Intransit"))
                                        || (singleOrder.status == "Cancelled") ? {color: 'red'} : {color: '#03C875'}}>
                                            {singleOrder.status ? singleOrder.status.toUpperCase() : ""}
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Payment Method
                                        </div>
                                        <div className='col-xs-8'>
                                            {singleOrder.payment_method}
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Payment Done?
                                        </div>
                                        <div className='col-xs-8'>
                                        <img src={(singleOrder.transaction_status === "Complete" || (singleOrder.payment_method === "Cash" && singleOrder.status === "Delivered")) ? 
                                            'https://image.popcontent.link/green_checkmark.svg' :
                                                        'https://image.popcontent.link/red_cross.svg'} />
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Net Total
                                        </div>
                                        <div className='col-xs-8'>
                                            {singleOrder.net_total ? singleOrder.net_total.toFixed(2) : "" }
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Rider Name
                                        </div>
                                        <div className='col-xs-8'>
                                            {singleOrder.third_party_delivery_details.rider_name ? singleOrder.third_party_delivery_details.rider_name : "" }
                                        </div>
                                    </div>
                                    <div className={`row ${base}__modal_table_row`}>
                                        <div className='col-xs-4 text--gray'>
                                            Rider Phone Number
                                        </div>
                                        <div className='col-xs-8'>
                                            {singleOrder.third_party_delivery_details.rider_phone_no ? singleOrder.third_party_delivery_details.rider_phone_no : "" }
                                        </div>
                                    </div>
                                    {singleOrder.bag_image && (
                                        <div>
                                            <div className={`row ${base}__modal_table_row`}>
                                                <div className='col-xs-4 text--gray'>
                                                    Bag Image
                                                </div>
                                                <div className='col-xs-8'>
                                                    <a href={singleOrder.bag_image} target="_blank"><img src={singleOrder.bag_image} height='100px' width='150px'/></a>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {singleOrder.produced_item_images && singleOrder.produced_item_images.length > 0 && (
                                        <div>
                                            <div className={`row ${base}__modal_table_row`}>
                                                <div className='col-xs-4 text--gray'>
                                                    Scanned Items
                                                </div>
                                                <div className='col-xs-8'>
                                                    { singleOrder.produced_item_images.map((image, index) => (
                                                        <a key={index} href={image} target="_blank">
                                                            <img src={image} height="100px" width="150px" style={{ marginRight: '10px', marginBottom: '10px' }} />
                                                        </a>                                                
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Modal>
                        </Fragment>
                    )}
                    <BarcodeReader
                        onError={this.handleError}
                        onScan={this.handleScanWrapper}
                    />
                    <ScanningBox
                        show={showScannedItemOnLiveDispatch}
                        scannedItem={scannedItem}
                        scannedItemSKU={scannedItemSKU}
                        scannedItemError={scannedItemError}
                        handleScan={this.handleScanWrapper}
                        loading={itemScanLoading}
                        originalItemImageLink={originalItemImageLink}
                        itemImage={image}
                        isCurrentPageFullScreen={false}
                    />
                </div>
            </Fragment>
        );
    }
}

export default AllOrders;
